import type { ClientGeoArea } from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { Chip } from 'react-native-paper';

import { hasItems } from '@/shared/utils/array';

const makeStyles = () =>
  StyleSheet.create({
    row: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 8,
      paddingHorizontal: 16,
      paddingTop: 12
    }
  });

export const TerritorialAuthorityOrtsteileChips: FC<{
  geoArea?: ClientGeoArea;
}> = ({ geoArea }) => {
  const styles = useMemo(() => makeStyles(), []);

  const ortsteile = useMemo(
    () => geoArea?.childGeoAreas?.filter((child) => child.leaf === true) ?? [],
    [geoArea]
  );

  if (!hasItems(ortsteile)) {
    return <></>;
  }

  return (
    <View style={styles.row}>
      {ortsteile.map((child) => (
        <Chip key={child.id}>{child.name}</Chip>
      ))}
    </View>
  );
};
